export { default } from "./JoinCouplesTherapyWaitlist"
